// Copyright (c) 2022 by Move Closer

import VueI18n from 'vue-i18n'

import { AllowedImageRatio, ProductData } from '../../../contexts'
import { ProductOrderData } from '../../../contexts/orders/contracts/orders'

import { CartItemProps } from '../../checkout/molecules/CartItem/CartItem.contracts'
import { toImageProps } from '../../shared/support'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 * @param originalProducts (products composed as ProductOrderData)
 * @param responseProducts (products from api response composed as ProductData)
 *
 * Load Order View with properly formatted data
 */
export const translateToOrderItem = (
  originalProducts: ProductOrderData[],
  responseProducts: ProductData[]
): CartItemProps[] => {
  const respArgValues = Object.values(responseProducts)
  const originalArgValues = Object.values(originalProducts)

  const skus = originalArgValues.map((item) => item.sku)

  /** Collection of all possible variants from given products */
  const variants = []
  for (const item of Object.values(responseProducts)) {
    for (const variant of Object.values(item.variants)) {
      variants.push(variant)
    }
  }

  return variants.filter((item) => skus.includes(item.sku)).map((item) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const id = respArgValues.find(product => product.sku.includes(item.sku))?.id
    const price = originalArgValues.find(product => product.sku === item.sku)?.price ? Number(originalArgValues.find(product => product.sku === item.sku)?.price.value) : 0
    const quantity = originalArgValues.find(product => product.sku === item.sku)?.quantity ? Number(originalArgValues.find(product => product.sku === item.sku)?.quantity) : 0

    return {
      id: id,
      thumbnail: Array.isArray(item.images) && item.images.length > 0 ? toImageProps(item.images[0], AllowedImageRatio.Square) : { src: '', alt: '' },
      title: item.attributes.brand ? String(item.attributes.brand) : '',
      price: price,
      description: item.name,
      quantity: quantity,
      isDisabled: true,
      urlPath: item.link,
      properties: [],
      sku: item.sku,
      volume: item.attributes.volume_name ?? item.attributes.capacity ?? undefined
    }
  })
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 * @param items
 * @param i18n
 *
 * Returns composed CartItems from orders that are missing in customer's order (missing / withdrawn, etc...)
 */
export const translateMissingOrderItems = (
  items: ProductOrderData[],
  i18n: VueI18n
): CartItemProps[] => {
  if (items.length === 0) {
    return []
  }

  return items.map((item) => {
    return {
      id: item.sku,
      thumbnail: { src: '', alt: '' },
      title: '',
      enhancedDesc: i18n.t('front.orders.views.OrderView.missingOrder').toString(),
      price: item.price.value,
      description: item.name,
      quantity: item.quantity,
      isDisabled: true,
      urlPath: '',
      properties: [],
      volume: undefined
    }
  })
}
